import React from "react";
import { useSelector } from "react-redux";
import { OrderStatus, TApiOrderDetails } from "../../../api/endpoints/Order";
import Col from "../../../components/Common/Col";
import Row from "../../../components/Common/Row";
import PageTitle from "../../../components/Ui/PageTitle";
import OrderStatusLabel from "../../../constants/OrderStatusLabel";
import OrderPolicy from "../../../policies/OrderPolicy";
import { selectUser } from "../../../store/selectors/UserSelectors";
import EditOrderButton from "../EditOrderButton";

const statusClass = new Map([
  [OrderStatus.ACCEPTED, "active"],
  [OrderStatus.COMPLETED, "active"],
  [OrderStatus.SUBMITTED, "pending"],
  [OrderStatus.ACTION_REQUIRED, "pending"],
  [OrderStatus.DRAFT, "draft"],
  [OrderStatus.REJECTED, "cancelled"],
  [OrderStatus.CANCELLED, "cancelled"]
]);

interface IProps {
  order: TApiOrderDetails;
}

const OrderHeader = (props: IProps) => {
  const { order } = props;
  const statusClassName = statusClass.get(order.status);
  const statusText = OrderStatusLabel.get(order.status);
  const user = useSelector(selectUser);

  return (
    <Row>
      <Col xs={12} md={9}>
        <PageTitle
          title={`Order #${order.id}`}
          endComponent={OrderPolicy.canEdit(user, order) && <EditOrderButton order={order} />}
        />
      </Col>

      <Col xs={12} md={3} className="order-status-wrapper">
        <span className={`order__summary--status details-page ${statusClassName}`}>
          {statusText}
        </span>
      </Col>
    </Row>
  );
};

export default OrderHeader;
